import React from "react";
import { Link } from "react-router-dom";
import FeatureHeader from "../components/FeatureHeader";
import "./Privacy.css";

export const PRIVACY_LAST_UPDATED = "November 4, 2026";
const INFO_EMAIL = "info@bugandfrog.org";

export default function Privacy() {
  return (
    <div className="privacy-page">
      <FeatureHeader badge={`Last updated ${PRIVACY_LAST_UPDATED}`} icon="heart" title="Privacy Policy">
        The families and volunteers who reach out to us trust us with personal details. Here is what
        we collect, why, and what we do with it.
      </FeatureHeader>

      <section>
        <div className="container privacy-layout">
          <article className="privacy-card">
            <h2>Who we are</h2>
            <p>
              The Bug and Frog Foundation is a nonprofit supporting NICU and PICU families. This
              policy covers bugandfrog.org. When it says "we" or "us," it means the foundation.
            </p>

            <h2>What we collect</h2>
            <p>We only collect what you choose to send us:</p>
            <ul>
              <li>
                <strong>Request support form:</strong> your name, address, your baby's weight, the
                kinds of support you're looking for, and, if you give it, your email address.
              </li>
              <li>
                <strong>Busy Bees sign-up:</strong> your name and email address, and, if you give
                them, your phone number, the crafts you enjoy, and any message you include.
              </li>
              <li>
                <strong>Donations:</strong> donations are processed by Givebutter. Your payment
                details go to Givebutter and its payment processors, not to us. Givebutter shares
                donor details such as your name, email address, and gift amount with us so we can
                thank you and keep records. See{" "}
                <a href="https://givebutter.com/privacy" target="_blank" rel="noopener noreferrer">
                  Givebutter's privacy policy
                </a>
                .
              </li>
              <li>
                <strong>Emails you send us:</strong> anything you include when you write to one of
                our addresses.
              </li>
            </ul>

            <h2>What we don't do</h2>
            <ul>
              <li>We don't sell, rent, or trade your information.</li>
              <li>We don't use advertising or analytics trackers on this website.</li>
              <li>We don't use your information for marketing by anyone else.</li>
            </ul>

            <h2>How we use your information</h2>
            <ul>
              <li>To review your request and get support to your family.</li>
              <li>To reply to you, including about Busy Bees sessions and supplies.</li>
              <li>To process, acknowledge, and keep records of donations.</li>
              <li>To keep the website working and secure, and to meet legal obligations.</li>
            </ul>

            <h2>Who else sees it</h2>
            <p>
              We share information only with the services that help us run the foundation, and only
              so they can do that work for us:
            </p>
            <ul>
              <li>Amazon Web Services, which hosts this website and delivers form emails to our inbox.</li>
              <li>Google Workspace, which hosts our email.</li>
              <li>Givebutter, which handles donations.</li>
            </ul>
            <p>
              This site loads its fonts from Google Fonts, which means your browser connects to
              Google, as it does on many websites. If you follow our Instagram link, Instagram's own
              policies apply there. We may also share information if the law requires it, or to
              protect someone's safety.
            </p>

            <h2>How long we keep it</h2>
            <p>
              We keep your information for as long as we need it to support you or work with you as a
              volunteer, and as long as we're required to for nonprofit and tax records. When we no
              longer need it, we delete it.
            </p>

            <h2>Keeping it safe</h2>
            <p>
              This site uses HTTPS, so what you send is encrypted on its way to us. Only foundation
              team members who need your information to help you can see it. No system is perfectly
              secure, but we take care to protect what you share.
            </p>

            <h2>Your choices</h2>
            <p>
              You can ask us what information we have about you, ask us to correct it, or ask us to
              delete it. Email <a href={`mailto:${INFO_EMAIL}`}>{INFO_EMAIL}</a> and we'll take care
              of it. Every form field marked optional really is optional.
            </p>

            <h2>Children</h2>
            <p>
              This website is meant for adults. The <Link to="/intake">Request support</Link> form
              asks parents and caregivers for some details about their baby so we can tailor support.
              We don't knowingly collect information directly from children under 18.
            </p>

            <h2>Changes to this policy</h2>
            <p>
              If we change how we handle information, we'll update this page and the date at the
              top.
            </p>

            <h2>Contact us</h2>
            <p>
              Questions about your privacy? Email us at{" "}
              <a href={`mailto:${INFO_EMAIL}`}>{INFO_EMAIL}</a>.
            </p>
          </article>
        </div>
      </section>
    </div>
  );
}
